import moment from "moment-timezone";

export const isSessionOnOrBeforeToday = (session, today = new Date()) => {
  if (!session?.event?.start_date) return false;

  return moment.tz(session.event.start_date, "Europe/Paris").isSameOrBefore(
    moment.tz(today, "Europe/Paris"),
    "day"
  );
};

export const getTeacherMonthlyStats = (teacher, sessions) => {
  let plannedSessionsCount = 0;
  let effectiveSessionsCount = 0;
  let effectivePointsTotal = 0;

  sessions.forEach((session) => {
    const plannedTeacherId = session?.schedule_item?.teacher?.id || session?.schedule_item?.teacher_id;
    if (plannedTeacherId === teacher.id) plannedSessionsCount += 1;
    const teacherId = session?.teacher?.id || session?.teacher_id || plannedTeacherId;
    if (teacherId !== teacher.id || !isSessionOnOrBeforeToday(session)) return;
    effectiveSessionsCount += 1;
    effectivePointsTotal += Number(session?.points) || 0;
  });

  return {
    ...teacher,
    planned_sessions_count: plannedSessionsCount,
    effective_sessions_count: effectiveSessionsCount,
    effective_points_total: effectivePointsTotal,
  };
};
